import { type BookmakersConfig } from '~/api/site-config-api/types';
import { GridTable } from '~/components/OddscheckerPlus/components/cxy';
import {
	type BettingInsightsContent,
	type EsIndex,
} from '~/configuration/betting-insights/types';
import {
	type BettingInsightsUI,
	type StyleSheet,
} from '~/configuration/betting-insights/ui/BettingInsightsUI';
import type ODDS_FORMAT from '~/enums/odds_format';

type DefaultTableBodyProps<
	TIndex extends EsIndex,
	TContent = BettingInsightsContent<TIndex>,
> = {
	bookmakers: BookmakersConfig;
	content: TContent;
	label: string;
	oddsFormat: ODDS_FORMAT;
	resultIndex: number;
	styles: StyleSheet;
	table: BettingInsightsUI<TIndex>['card']['table'];
};

export function DefaultTableBody<TIndex extends EsIndex>({
	bookmakers,
	content,
	label,
	oddsFormat,
	resultIndex,
	styles,
	table,
}: DefaultTableBodyProps<TIndex>) {
	return (
		<GridTable.Body
			className={table.showAdditionalTitle ? styles.additionalTitle : ''}
		>
			<GridTable.Row>
				{table.cells.map((cell, index) => {
					return (
						<GridTable.Cell
							alignItems={cell.alignItems}
							className={cell.className ? styles[cell.className] : ''}
							highlight={cell.highlight && cell.highlight({ content })}
							isFullWidthMobile={cell.isFullWidthMobile}
							isMain={cell.isMain}
							justifyContent={cell.justifyContent}
							key={`${label}-cell-${index}`}
							order={cell.order}
							start={cell.start}
						>
							{cell.render({
								content,
								bookmakers,
								oddsFormat,
								resultIndex,
							})}
						</GridTable.Cell>
					);
				})}
			</GridTable.Row>
		</GridTable.Body>
	);
}
